const experiment = require("../config/memberSeoTitleExperiment.json");

const applyMemberSeoTitleExperiment = (route, config = experiment) => {
  if (config.status !== "active" || route.memberSeoRouteKind !== "city" || !config.taskSlugs.includes(route.memberSeoTask.taskSlug)) return route;
  const citySlug = route.memberSeoCity.slug;
  const pair = config.pairs.find((item) => [item.treatment.slug, item.control.slug].includes(citySlug));
  if (!pair) return route;
  const arm = pair.treatment.slug === citySlug ? "treatment" : "control";
  // Keep this dual Node/browser module free of Babel's ESM spread helper imports.
  return Object.assign({}, route, {
    title: arm === "treatment"
      ? `${route.memberSeoCity.city}, ${route.memberSeoCity.stateCode}: ${route.memberSeoTask.label} | Linked Lives`
      : route.title,
    seoExperiment: { experimentKey: config.experimentKey, cohort: arm, pairId: pair.pairId },
  });
};
module.exports = { applyMemberSeoTitleExperiment };
